import React from "react";
import PropTypes from "prop-types";
import { Badge } from "@opendate-app/setlist";

export default function ClassSummaryCard({ card, layout = "stacked", children = null }) {
  return (
    <div className={`pc-summary-card pc-summary-card--${layout}`} data-testid="class-summary-card">
      <div className="pc-summary-card__media">
        {card.imageUrl ? <img src={card.imageUrl} alt="" /> : <span className="pc-summary-card__placeholder" aria-hidden="true" />}
      </div>
      <div className="pc-summary-card__body">
        {card.chips.length > 0 && (
          <div className="pc-summary-card__chips">
            {card.chips.map((chip, index) => <Badge key={chip} color={index === 0 ? "brand" : "gray"} size="sm">{chip}</Badge>)}
          </div>
        )}
        <h2 className="pc-summary-card__title">{card.name}</h2>
        {card.description && layout === "wide" && <p className="pc-summary-card__description">{card.description}</p>}
        {card.meta.length > 0 && <p className="pc-summary-card__meta">{card.meta.join(" · ")}</p>}
      </div>
      {children && <div className="pc-summary-card__footer">{children}</div>}
    </div>
  );
}

ClassSummaryCard.propTypes = {
  card: PropTypes.shape({
    name: PropTypes.string.isRequired,
    imageUrl: PropTypes.string,
    description: PropTypes.string,
    chips: PropTypes.arrayOf(PropTypes.string).isRequired,
    meta: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
  layout: PropTypes.oneOf(["stacked", "wide"]),
  children: PropTypes.node,
};
